import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

const BRIDGENEXT_PURPLE = '#5F00AA'

export default function Header() {
  const { currentUser, logout, hasMinRole } = useAuth()

  const getRoleBadgeColor = () => {
    if (hasMinRole('Super Administrator')) return 'bg-red-100 text-red-800'
    if (hasMinRole('Administrator')) return 'bg-orange-100 text-orange-800'
    if (hasMinRole('Project Administrator')) return 'bg-blue-100 text-blue-800'
    if (hasMinRole('Project Manager')) return 'bg-green-100 text-green-800'
    return 'bg-gray-100 text-gray-800'
  }

  const getUserRole = () => {
    const roles = currentUser?.systemRoles || []
    if (roles.includes('Super Administrator')) return 'Super Administrator'
    if (roles.includes('Administrator')) return 'Administrator'
    if (roles.includes('Project Administrator')) return 'Project Administrator'
    if (roles.includes('Project Manager')) return 'Project Manager'
    return 'Contributor'
  }

  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-lg"
              style={{ backgroundColor: BRIDGENEXT_PURPLE }}
            >
              B
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Bridgenext</h1>
              <p className="text-xs text-gray-500">IT Acquisition Playbook</p>
            </div>
          </div>

          <div className="flex items-center gap-6">
            {hasMinRole('Administrator') && (
              <Link to="/admin" className="text-gray-700 hover:text-gray-900 font-medium">
                Admin Panel
              </Link>
            )}

            <div className="flex items-center gap-3 pl-6 border-l border-gray-200">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{currentUser?.displayName}</p>
                <span className={`inline-block px-2 py-1 text-xs font-semibold rounded ${getRoleBadgeColor()}`}>
                  {getUserRole()}
                </span>
              </div>

              <button
                onClick={logout}
                className="ml-4 px-4 py-2 text-sm font-medium text-white rounded-lg"
                style={{ backgroundColor: BRIDGENEXT_PURPLE }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
